import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/flame.vue
var o = {
	name: "DtIconFlame",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--flame"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Flame",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.807 1.039a.498.498 0 0 1 .685.372c.228 1.127.91 2.22 1.82 2.949C9.4 5.23 9.998 6.31 10 7.494V7.5a4 4 0 1 1-8 0c0-.687.253-1.368.61-1.813A.5.5 0 0 1 3.5 6a.75.75 0 0 0 1.5.003V6c0-.43-.106-.628-.29-.976a12.41 12.41 0 0 1-.157-.3c-.325-.65-.369-1.299-.141-1.93.217-.605.669-1.152 1.25-1.663a.497.497 0 0 1 .145-.092Zm-.36 3.237c.037.074.077.148.118.223.203.375.434.8.435 1.497V6a1.75 1.75 0 0 1-2.982 1.242A1.932 1.932 0 0 0 3 7.5a3 3 0 0 0 6 .005V7.5c0-.815-.402-1.631-1.312-2.36a6.285 6.285 0 0 1-1.933-2.68 2.32 2.32 0 0 0-.403.673c-.128.358-.116.723.095 1.144Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=flame.js.map